import { Routes } from '@angular/router';
import { AuthenticationGuard, AuthorizationGuard } from '@softline/auth';

export const garageReportRoutes: Routes = [
  {
    path: 'garage-report',
    title: 'Werkstattbericht',
    children: [
      {
        path: 'search',
        loadComponent: () => import('./pages/mechanic-search/mechanic-search.component'),
      },
      {
        path: 'mechanic-report/:mechanicId',
        loadComponent: () => import('./pages/mechanic-report/mechanic-report.component'),
        pathMatch: 'full',
      },
      {
        path: 'mechanic-report/:mechanicId/order-report/:orderId',
        loadComponent: () => import('./pages/order-report/order-report.component'),
        pathMatch: 'full',
      },
      {
        path: '**',
        redirectTo: '/garage-report/search',
      },
    ],
    canActivate: [AuthenticationGuard, AuthorizationGuard],
    data: {
      permission: 'GARAGE.REPORT',
    },
  },
];
